/* React */
import { useEffect } from "react";

/* React Router */
import { useLocation } from "react-router";

/* React Redux */
import { useDispatch, useSelector } from "react-redux";
import { setDisabled } from "src/redux/features/menu/secondary-menu/secondaryMenuSlice";
import { RootState } from "src/redux/store";

/* Constants */
import { Paths } from "src/shared/constants/common/Paths";
import { DisabledMenuPaths } from "src/shared/constants/menu/DisabledMenuPaths";

export const useToggleSecondaryMenu = () => {
  const { pathname } = useLocation();
  const dispatch = useDispatch();

  const insightsFilterState = useSelector(
    (state: RootState) => state.insightsFilter
  );

  const { mainCondition } = insightsFilterState;

  useEffect(() => {
    /**
     * 'DisabledMenuPaths' is an array of paths
     * that should not allow the secondary menu to be toggled.
     */
    if (DisabledMenuPaths.includes(pathname as Paths)) {
      dispatch(setDisabled(true));
      return;
    }

    const isInsights = pathname.startsWith(Paths.INSIGHTS);

    if (!isInsights) {
      dispatch(setDisabled(false));
      return;
    }

    if (mainCondition.value === undefined) return;

    dispatch(setDisabled(mainCondition.value === null));
  }, [location.pathname, mainCondition.value, dispatch]);
};
